import { FC } from 'react';
import MoreMenu from '@/components/more-menu';
import CopyMenuItem from '@/components/more-menu/copy-menu-item';

interface Props {
  traceId?: string | null;
  conversationId?: string | null;
}

const UserEventMenu: FC<Props> = ({ traceId, conversationId }) => {
  return (
    <MoreMenu menuId="user-event-menu" hideCopy>
      <CopyMenuItem label="Copy User Event URL" icon="link" value={window.location.href} />
      {!!traceId && <CopyMenuItem label="Copy Trace ID" icon="copy-id" value={traceId} />}
      {!!conversationId && (
        <CopyMenuItem label="Copy Conversation ID" icon="copy-id" value={conversationId} />
      )}
    </MoreMenu>
  );
};

export default UserEventMenu;
